export * from './goal-review';
export * from './goal-accomplishment';
export * from './self-declaration';

export function getAllYearSince(year: number = 2023): number[] {
  const currentYear = new Date().getFullYear();
  const years: number[] = [];

  for (let i = year; i <= currentYear + 1; i++) {
    years.push(i);
  }

  return years.sort((a, b) => b - a);
}
